import { Component, Input } from "@angular/core";
import { Nullable } from "src/app/support/nullable";

@Component({
  selector: "snt-page-detail-header-link",
  template: "",
  standalone: false
})
export class PageDetailHeaderLinkComponent {
  @Input() href: Nullable<string> = null;
  @Input() text: string = "";
}
